<template>
  <div class="offcn-teacher-open">
  	<p class="offcn-live-standard">中公教育教辅工具下载及使用说明</p>
  	<div class="offcn-live-statement">
		<p>说明:</p>
		<p>1、请必须于授课前同网校工作人员确定所使用的客户端,安装相应软件并确保升级至最新版本。</p>
		<p>2、请于课前按照网校工作人员通知,准时进行网络试音准备工作</p>
		<p>3、各客户端请提前熟悉平台使用,熟悉操作</p>
		<p>4、课前阅读网校直播课授课纪律要求,并严格遵守。</p>
  	</div>
  	<div class="offcn-live-requirement">
	    <button @click='downpdf'>网校直播课授课纪律要求</button>
	    <button @click='downppt'>课件PPT参考模板下载</button>
	    <span>提取码:kk3q</span>
  	</div>
  	<p class="offcn-live-client">客户端下载:</p>
    <p class="offcn-live-lineone"><img class="offcn_pic" src="./livedownload.png">中公直播(上直播课的工具)</p>
    <div class="offcn-live-mainlive">
		<p class="offcn-operation-tip">
			<span>电脑客户端下载:</span>
			<button @click='down_mainlive_client'>下载Windows客户端</button>
		</p>
		<p class="offcn-operation-tip">
			<span class="offcn-live-surplus">:</span>
			<button @click='down_minilive_client'>下载MacOS客户端</button>
		</p>
    </div>
	<div class="offcn-live-mainlive">
		<p class="offcn-operation-tip">
			<span>手机客户端下载:</span>
			<button class="ios" @click='mainlive_instructions'>IOS端下载
				<span class="qr_code"><img class="app_pic" src="./ios1.png"><span>扫码下载“中公直播APP”</span><img class="bottom" src="./bottom_round.png"></span>
			</button>
		</p>
		<p class="offcn-operation-tip">
			<span class="offcn-live-surplus">:</span>
			<button class="android" @click='mainlive_specifications'>Android端下载
				<span class="qr_code"><img class="app_pic" src="./android1.png"><span>无法使用微信扫一扫，请使用QQ或其他工具</span><img class="bottom" src="./bottom_round.png"></span>
			</button>
		</p>
	</div>
	<div class="offcn-live-mainlive">
		<p class="offcn-operation-tip">
			<span>使用说明和网校注意事项:</span>
			<button @click='mainlive_instructions'>大班课使用说明</button>
		</p>
		<p class="offcn-operation-tip">
			<span class="offcn-live-surplus">:</span>
			<button @click='mainlive_specifications'>大班课使用视频</button>
		</p>
		<p class="offcn-operation-tip">
			<span class="offcn-live-surplus">:</span>
			<button @click='minilive_instructions'>小班课使用说明</button>
		</p>
		<p class="offcn-operation-tip">
			<span class="offcn-live-surplus">:</span>
			<button @click='mainlive_becareful'>网校注意事项视频</button>
		</p>
	</div>
	<p class="offcn-live-lineone"><img class="offcn_pic" src="./im.jpg">中公云信(IM服务的工具)</p>
	<p class="offcn-operation-tip">
		<span>电脑客户端下载:</span>
		<button @click='down_im_client'>下载Windows客户端</button>
	</p>
	<div class="offcn-live-onenine">
		<p class="offcn-operation-tip">
			<span>手机客户端下载:</span>
			<button class="ios">IOS端下载
				<span class="qr_code"><img class="app_pic" src="./ios.png"><span>扫码下载“中公直播APP”</span><img class="bottom" src="./bottom_round.png"></span>
			</button>
		</p>
		<p class="offcn-operation-tip">
			<span class="offcn-live-surplus">:</span>
			<button class="android">Android端下载
				<span class="qr_code"><img class="app_pic" src="./android.png"><span>无法使用微信扫一扫，请使用QQ或其他工具</span><img class="bottom" src="./bottom_round.png"></span>
			</button>
		</p>
	</div>
	<p class="offcn-operation-tip">
		<span>使用说明:</span>
		<button @click='im_instructions'>查看使用视频</button>
	</p>
    <div class="offcn-live-attention">
		<p>注意事项:</p>
		<p>1、上课前请检查自己的网络环境,保证网络顺畅。</p>
		<p>2、请选择安静的环境上课。</p>
		<p>3、上课需要的设备包括:电脑,麦克风,摄像头,扬声器,如缺失请及时告知网校工作人员。</p>
		<p>4、若有疑问请及时咨询工作人员或联系技术老师。</p>
    </div>
    <p class="offcn-live-footer">——北京中公教育科技有限公司——</p>
  </div>
</template>

<script>
export default {
  methods: {
  	downpdf () {
  		window.open('static/use_prior_notice.pdf')
  	},
  	downppt () {
  		window.open('https://pan.baidu.com/s/1zVuMo_wB0TVUYTaPFAID6A')
  	},
  	down_mainlive_client () {
  		window.open('https://desktop.offcncloud.com/offcnLiveUpdate/offcnLive/windows/offlinePackage/ZgLiveSetup.exe')
    },
    down_minilive_client () {
      window.open('https://desktop.offcncloud.com/offcnLiveUpdate/offcnLive/mac/offlinePackage/ZgLiveSetup.pkg')
  	},
  	mainlive_instructions () {
  		window.open('https://docs.qq.com/doc/DU3p6aHhUS2d5a0tY?opendocxfrom=admin')
    },
    minilive_instructions () {
  		window.open('https://docs.qq.com/doc/DV0Z6UWVCcVhEVlNz')
  	},
  	mainlive_specifications () {
  		window.open('http://e.eoffcn.com/space.php?do=playvideo&op=play_demo&aid=1&lid=33285&ltype=31')
    },
    mainlive_becareful () {
      window.open('https://v.youku.com/v_show/id_XMzc1NDI4NDczMg==.html')
    },
    down_im_client () {
      window.open('http://desktop.offcncloud.com/offcnLiveUpdate/offcnTalk/windows/offlinePackage/OffcnTalkSetup.exe')
    },
    im_instructions () {
	  window.open('http://pcvod.offcncloud.com/#/vod?account=5zg20jrbh0')
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.offcn-teacher-open
{
	width: 1000px;
	margin: 0 auto;
}
.offcn-live-standard
{
	padding-top: 20px;
	font-size: 36px;
	font-weight: 600;
}
.offcn-live-statement
{
	margin-top: 30px;
	line-height: 30px;
}
.offcn-live-statement p:first-child,.offcn-live-client,.offcn-live-attention p:first-child
{
	font-weight: 600;
	font-size: 20px;
	margin-bottom: 12px;
}
.offcn-live-requirement span
{
	margin-top: 24px;
}
.offcn-live-requirement button:first-child
{
	margin-right: 28px;
}
.offcn-live-client
{
	margin-top: 60px;
}
.offcn-live-lineone
{
	display: flex;
	align-items: center;
	font-size: 18px;
	margin-top: 30px;
	img
	{
		margin-right: 16px;
	}
	.offcn_pic
	{
		width: 64px;
	}
}
button
{
	width: 172px;
	padding: 11px 0;
	font-size: 15px;
	background: white;
	border: 1px solid;
	margin-top: 24px;
	outline: none;
	cursor: pointer;
}
button:hover
{
	background: #ff895f;
	color: white;
}
.offcn-live-mainlive,.offcn-live-onenine
{
	display: flex;
	flex-wrap: wrap;
	margin-top: 10px;
}
.offcn-live-mainlive
{
	padding-bottom: 40px;
}
.offcn-live-mainlive button:first-child,.offcn-live-mainlive button:nth-child(2),.offcn-live-mainlive button:nth-child(3),.offcn-live-mainlive button:nth-child(4),
.offcn-live-onenine button:first-child,.offcn-live-onenine button:nth-child(2)
{
	margin-right: 28px;
}
.offcn-live-attention
{
	line-height: 30px;
	margin-top: 30px;
}
.offcn-live-footer
{
	text-align: center;
	margin-top: 50px;
	padding-bottom: 50px;
}
.offcn-live-surplus
{
	visibility: hidden;
}
.offcn-operation-tip
{
	display: flex;
	flex-direction: column;
	margin-top: 24px;
	span
	{
		font-weight: bold;
	}
	.android, .ios {
		position: relative;
	}
	.qr_code
	{
		display: none;
		position: absolute;
		bottom: 60px;
		width: 172px;
		text-align: center;
		background: #ffffff;
		box-shadow: 0 0 12px #d9d9d9;
		.app_pic {
			width: 160px;
		}
		span {
			display: block;
			font-size: 12px;
			padding-bottom: 10px;
		}
		.bottom {
			position: absolute;
		}
	}
	.android:hover span
	{
		display: block;
		color: #000;
	}
	.ios:hover span
	{
		display: block;
		color: #000;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-downloads/downloads.vue